import { useState, useEffect } from "react";

import "./App.css";

import classnames from "classnames";
// Avatar decoration handled by Avatar component
import Avatar from "./components/Avatar/Avatar";
import { SHOP_ENABLED } from "./config/appMode";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { useAuthState } from "react-firebase-hooks/auth";

// eslint-disable-next-line
import { auth, db } from "./util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  updateDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";

import BarLoader from "react-spinners/BarLoader";

import { useTranslation } from "react-i18next";

import Select from "react-select";
import makeAnimated from "react-select/animated";

// eslint-disable-next-line
import { BsInstagram, BsTwitterX } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";
import { IoChevronDown, IoChevronUp, IoClose } from "react-icons/io5";
import { TbBell } from "react-icons/tb";
import { TbWallet } from "react-icons/tb";

import LoginPage from "./pages/auth/LoginPage";
import RegisterPage from "./pages/auth/RegisterPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";

import DashboardPage from "./pages/main/DashboardPage";
import AccountPage from "./pages/main/AccountPage";
import AboutUsPage from "./pages/main/AboutUsPage";
import NewsPage from "./pages/main/NewsPage";
import SportsPage from "./pages/main/SportsPage";
import ContactPage from "./pages/main/ContactPage";
import ShopPage from "./pages/main/ShopPage";
import TermsAndConditionsPage from "./pages/main/TermsAndConditionsPage";
import PrivacyPolicyPage from "./pages/main/PrivacyPolicyPage";
import NotificationsPage from "./pages/main/account/NotificationsPage";
import FriendsPage from "./pages/main/account/FriendsPage";
import ChampionsRoadPage from "./pages/main/account/ChampionsRoadPage";
import AchievementsPage from "./pages/main/account/AchievementsPage";
import ProfilePage from "./pages/main/account/ProfilePage";
import WalletHistoryPage from "./pages/main/account/WalletHistoryPage";
import ChangeAvatarPage from "./pages/main/account/profile/ChangeAvatarPage";
import ChangeBannerPage from "./pages/main/account/profile/ChangeBannerPage";
import ChangeUsernamePage from "./pages/main/account/profile/ChangeUsernamePage";
import CheckoutPage from "./pages/main/CheckoutPage";
import NewsArticlePage from "./pages/main/NewsArticlePage";
import AdminPage from "./pages/main/AdminPage";
import AdminNewsArticlePage from "./pages/main/admin/AdminNewsArticlePage";
import AdminCreateNewsArticlePage from "./pages/main/admin/AdminCreateNewsArticlePage";
import PlayPage from "./pages/main/PlayPage";
import JoinALeaguePage from "./pages/main/play/JoinALeaguePage";
import LeaguePage from "./pages/main/play/LeaguePage";
import RoomPage from "./pages/main/play/RoomPage";
import SingleUserPage from "./pages/main/SingleUserPage";
import Swal from "sweetalert2";
import AdminUserPage from "./pages/main/admin/AdminUserPage";
import AdminCreateEventPage from "./pages/main/admin/events/AdminCreateEventPage";
import AdminCreateGroupPage from "./pages/main/admin/groups/AdminCreateGroupPage";
import AdminSingleGroupPage from "./pages/main/admin/groups/AdminSingleGroupPage";
import RecoverCorruptedGroups from "./pages/main/admin/groups/RecoverCorruptedGroups";
import { Button, Modal, ModalBody } from "reactstrap";
import AdminCreateRewardPage from "./pages/main/admin/rewards/AdminCreateRewardPage";
import AdminSingleRewardPage from "./pages/main/admin/rewards/AdminSingleRewardPage";
import ChallengesPage from "./pages/main/account/ChallengesPage";
import AdminCreateCouponPage from "./pages/main/admin/coupons/AdminCreateCouponPage";
import AdminSingleCouponPage from "./pages/main/admin/coupons/AdminSingleCouponPage";
import AdminSingleLeaguePage from "./pages/main/admin/leagues/AdminSingleLeaguePage";
import AdminCreateLeaguePage from "./pages/main/admin/leagues/AdminCreateLeaguePage";
import AdminSingleRoomPage from "./pages/main/admin/rooms/AdminSingleRoomPage";
import AdminCreateRoomPage from "./pages/main/admin/rooms/AdminCreateRoomPage";
import AdminCreateBundlePage from "./pages/main/admin/bundles/AdminCreateBundlePage";
import AdminSingleBundlePage from "./pages/main/admin/bundles/AdminSingleBundlePage";
import AdminSingleProductPage from "./pages/main/admin/products/AdminSingleProductPage";
import AdminCreateProductPage from "./pages/main/admin/products/AdminCreateProductPage";
import PaymentSuccessfulPage from "./pages/main/shop/PaymentSuccessfulPage";
import PaymentUnsuccessfulPage from "./pages/main/shop/PaymentUnsuccessfulPage";
import VisionAndMissionPage from "./pages/main/company/VisionAndMissionPage";
import UserInfoPage from "./pages/main/account/profile/UserInfoPage";
import ChatRoomPage from "./pages/main/chat/ChatRoomPage";
import { MdNewReleases } from "react-icons/md";
import WelcomeTutorialModal from "./components/modals/WelcomeTutorialModal";
import { AiOutlineClear } from "react-icons/ai";
import AdminSingleBannerPage from "./pages/main/admin/banners/AdminSingleBannerPage";
import AdminAddBannerPage from "./pages/main/admin/banners/AdminAddBannerPage";
import AdminRewardRedemptionHistoryPage from "./pages/main/admin/rewards/AdminRewardRedemptionHistoryPage";
import AdminWalletTransactionsPage from "./pages/main/admin/AdminWalletTransactionsPage";
import AdminPrizeDistributionsPage from "./pages/main/admin/AdminPrizeDistributionsPage";

// After a user logs in or registers, send them back to the page they were
// trying to reach (e.g. a tournament they tapped JOIN on while logged out),
// stored in localStorage as "postAuthRedirect". Falls back to home.
function PostAuthRedirect() {
  let target = "/";
  try {
    target = localStorage.getItem("postAuthRedirect") || "/";
  } catch (e) {
    // ignore
  }
  useEffect(() => {
    try {
      localStorage.removeItem("postAuthRedirect");
    } catch (e) {
      // ignore
    }
  }, []);
  return <Navigate to={target} replace />;
}

function App() {
  // const [user, loading] = useAuthState(auth);

  // if (loading) return (
  // 	<div className='loadingPage'>
  //     <BarLoader color="#36A18B" />
  //   </div>
  // )

  return (
    // user ?
    <MainRoutes />
    //  : <AuthRoutes />
  );
}

// function AuthRoutes() {
//   return (
//     <Router>
//       <Routes>
//         <Route path='/*' element={<Navigate to='/login' />}/>
//         <Route path="/login" element={<LoginPage />} />
//         <Route path="/register" element={<RegisterPage />} />
//         <Route path="/reset" element={<ResetPasswordPage />} />
//       </Routes>
//     </Router>
//   )
// }

function MainRoutes() {
  const currentRoute = window.location.href.split("/")[3];

  // eslint-disable-next-line
  const [user, loading] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const rewardFounder = async (userData) => {
    if (
      userData.email === "arqaegm@outlook.com" ||
      userData.email === "manuelcornejo579@gmail.com" ||
      userData.email === "nmonge056@gmail.com" ||
      userData.email === "alfonsosecomorales@gmail.com" ||
      userData.email === "carloszeledon799@gmail.com" ||
      userData.email === "albertocia04031989@gmail.com" ||
      userData.email === "mlopez0559@gmail.com" ||
      userData.email === "josesalazar160693@gmail.com" ||
      userData.email === "gabpastori7@gmail.com" ||
      userData.email === "joelrivas0802@gmail.com" ||
      userData.email === "salandrajose1997@gmail.com" ||
      userData.email === "luisemiliodada@gmail.com" ||
      userData.email === "sprangerventures@gmail.com"
    ) {
      if (!userData.founderHasBeenRewarded) {
        try {
          const userRef = query(
            collection(db, "users"),
            where("uid", "==", user?.uid),
          );
          const findUsers = await getDocs(userRef);
          findUsers.forEach(async (userObject) => {
            const getUser = doc(db, "users", userObject.id);
            await updateDoc(getUser, {
              founderHasBeenRewarded: true,
              tickets: (userData.tickets += 600),
            });
          });

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert(err.message);

          setIsLoading(false);
        }
        try {
          const bannerRef = query(
            collection(db, "banners"),
            where("category", "==", "Founders"),
          );
          const findBanners = await getDocs(bannerRef);

          findBanners.forEach(async (banner) => {
            const bannerData = banner.data();
            const getBanner = doc(db, "banners", banner.id);
            await updateDoc(getBanner, {
              beneficiaryUids:
                bannerData?.beneficiaryUids?.length > 0
                  ? [...bannerData.beneficiaryUids, user.uid]
                  : [user.uid],
            });
          });

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert(err.message);

          setIsLoading(false);
        }
        try {
          const avatarRef = query(
            collection(db, "avatars"),
            where("isFounders", "==", true),
          );
          const findAvatars = await getDocs(avatarRef);

          findAvatars.forEach(async (avatar) => {
            const avatarData = avatar.data();
            const getAvatar = doc(db, "avatars", avatar.id);
            await updateDoc(getAvatar, {
              beneficiaryUids:
                avatarData?.beneficiaryUids?.length > 0
                  ? [...avatarData.beneficiaryUids, user.uid]
                  : [user.uid],
            });
          });

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert(err.message);

          setIsLoading(false);
        }
        Swal.fire({
          titleText: "Welcome founder!",
          text: "Thanks for being part of Sport League from the very beginning! As a reward, you've earned 600 shop tickets and a Founders avatar & banner!",
          icon: "success",
          confirmButtonColor: "#005EE1",
          confirmButtonText: "OKAY",
        });
      }
    }
  };

  const { t, i18n } = useTranslation("common");

  const languageOptions = [
    { value: "en", label: "English" },
    { value: "es", label: "Español" },
  ];

  const [userData, setUserData] = useState();
  const [userRole, setUserRole] = useState();
  const [userAvatar, setUserAvatar] = useState();
  // Initialize language state from i18n so the toggler reflects the actual UI language
  const defaultLang =
    i18n?.language && i18n.language.startsWith("es")
      ? { value: "es", label: "Español" }
      : { value: "en", label: "English" };

  const [language, setLanguage] = useState(defaultLang);
  const fetchUserData = async () => {
    try {
      setIsLoading(true);

      const q = await query(
        collection(db, "users"),
        where("uid", "==", user?.uid),
      );
      const queryDoc = await getDocs(q);
      if (queryDoc.docs.length > 0) {
        const data = queryDoc.docs[0].data();
        setUserData(data);
        setUserRole(data?.role);
        setUserAvatar(data?.avatar);
        rewardFounder(data);
        // TODO: WHAT IF USER OBJECT HAS NO LANGUAGE FIELD
        if (data.language) {
          setLanguage(data.language);
          i18n.changeLanguage(data.language.value);
        } else {
          setLanguage({
            value: "es",
            label: "Español",
          });
          i18n.changeLanguage("es");
        }
        // if (!data?.hasLoggedIn){
        //   Swal.fire({
        //     text: "Our app is not directed at children. If you are a minor, please ask your parent or guardian to read and accept our Terms & Conditions and Privacy Policy. By tapping OKAY you accept our Terms & Conditions and Privacy Policy.",
        //     icon: 'warning',
        //     confirmButtonColor: '#005EE1',
        //     confirmButtonText: "OKAY",
        //   });

        //   try {
        //     const userRef = query(collection(db, "users"), where("uid", "==", user?.uid));
        //     const findUsers = await getDocs(userRef);
        //     findUsers.forEach( async (userObject) => {

        //       const getUser = doc(db, 'users', userObject.id);
        //       await updateDoc(getUser, {
        //         hasLoggedIn: true
        //       });
        //     });

        //     setIsLoading(false);
        //   } catch (err) {
        //     console.error(err);
        //     alert(err.message);

        //     setIsLoading(false);
        //   }
        // }

        // Sports Pass feature removed — membership avatarDecoration drives avatar ring now.

        setIsLoading(false);
      }
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  // Listen for wallet updates from other components (e.g., ShopPage)
  useEffect(() => {
    const handleWalletUpdate = () => {
      if (user) {
        fetchUserData();
      }
    };

    window.addEventListener("userWalletUpdated", handleWalletUpdate);

    return () => {
      window.removeEventListener("userWalletUpdated", handleWalletUpdate);
    };
    // eslint-disable-next-line
  }, [user]);

  const setLang = async (e, source) => {
    if (user) {
      try {
        setIsLoading(true);

        const userRef = query(
          collection(db, "users"),
          where("uid", "==", user?.uid),
        );
        const findUsers = await getDocs(userRef);
        findUsers.forEach(async (userObject) => {
          const getUser = doc(db, "users", userObject.id);
          await updateDoc(getUser, {
            language: e,
          });

          i18n.changeLanguage(e.value);
          setLanguage(e);
          if (source !== "desktop") {
            toggleSidebar();
          }

          setIsLoading(false);
        });
      } catch (err) {
        console.error(err);
        alert("An error occured while changing language");
      }
    } else {
      i18n.changeLanguage(e.value);
      setLanguage(e);
      if (source !== "desktop") {
        toggleSidebar();
      }
    }
  };

  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
  const toggleSidebar = () => {
    setSidebarIsOpen(!sidebarIsOpen);
  };

  // eslint-disable-next-line
  const [achievementsUnlocked, setAchievementsUnlocked] = useState();
  const fetchAchievements = async () => {
    try {
      setIsLoading(true);

      let fetchedAchievementsUnlocked = 0;

      const q = query(collection(db, "achievements"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newAchievement = doc.data();
        if (newAchievement.achieverUids.includes(user.uid)) {
          fetchedAchievementsUnlocked += 1;
        }
      });

      setAchievementsUnlocked(fetchedAchievementsUnlocked);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching achievements unlocked");
    }
  };

  useEffect(() => {
    if (user) {
      fetchAchievements();
    }
    // eslint-disable-next-line
  }, [user]);

  const [walletModalIsOpen, setWalletModalIsOpen] = useState(false);
  const toggleWalletModal = () => {
    setWalletModalIsOpen(!walletModalIsOpen);
  };

  const [notifications, setNotifications] = useState();
  const fetchNotifications = async () => {
    try {
      setIsLoading(true);

      let fetchedNotifications = [];
      const seenKeys = new Set();

      const q = query(
        collection(db, "notifications"),
        where("recipientUid", "==", user?.uid),
      );
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newNotification = doc.data();
        if (!newNotification.isRead) {
          // Deduplicate by content to prevent showing duplicate notifications
          const key = `${newNotification.title}|${newNotification.description}`;
          if (!seenKeys.has(key)) {
            seenKeys.add(key);
            fetchedNotifications.push(newNotification);
          }
        }
      });

      fetchedNotifications.sort((a, b) => {
        return new Date(b.dateCreated) - new Date(a.dateCreated);
      });

      setNotifications(fetchedNotifications);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching notifications");
    }
  };

  useEffect(() => {
    if (user) {
      fetchNotifications();
    }
    // eslint-disable-next-line
  }, [user]);

  const [notificationsModalIsOpen, setNotificationsModalIsOpen] =
    useState(false);
  const toggleNotificationsModal = () => {
    setNotificationsModalIsOpen(!notificationsModalIsOpen);
  };

  const animatedComponents = makeAnimated();

  const [footerCompanyAccordionIsOpen, setFooterCompanyAccordionIsOpen] =
    useState(false);
  const toggleFooterCompanyAccordion = () => {
    setFooterCompanyAccordionIsOpen(!footerCompanyAccordionIsOpen);
  };

  const [
    footerCustomerServiceAccordionIsOpen,
    setFooterCustomerServiceAccordionIsOpen,
  ] = useState(false);
  const toggleFooterCustomerServiceAccordion = () => {
    setFooterCustomerServiceAccordionIsOpen(
      !footerCustomerServiceAccordionIsOpen,
    );
  };

  const toggleLanguage = () => {
    if (language.value === "en") {
      setLang(
        {
          value: "es",
          label: "Español",
        },
        "desktop",
      );
    } else {
      setLang(
        {
          value: "en",
          label: "English",
        },
        "desktop",
      );
    }
  };

  const markNotificationAsRead = async (notification) => {
    try {
      const notificationRef = query(
        collection(db, "notifications"),
        where("uid", "==", notification.uid),
      );
      const findNotifications = await getDocs(notificationRef);
      findNotifications.forEach(async (notificationObject) => {
        const getNotification = doc(db, "notifications", notificationObject.id);
        await updateDoc(getNotification, {
          isRead: true,
        });
      });

      const newNotifications = notifications.map((notif) => {
        if (notif.uid === notification.uid) {
          return {
            ...notif,
            isRead: true,
          };
        }
        return notif;
      });

      setNotifications(newNotifications);
    } catch (err) {
      console.error(err);
      alert("An error occured while marking notification as read");
    }
  };

  const clearNotifications = async () => {
    Swal.fire({
      text: "Are you sure you want to clear your notifications?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, CLEAR",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);
          const q = query(
            collection(db, "notifications"),
            where("recipientUid", "==", user?.uid),
          );
          const docs = await getDocs(q);
          // Delete all notifications instead of just marking as read
          const deletePromises = [];
          docs.forEach((docObj) => {
            const notificationRef = doc(db, "notifications", docObj.id);
            deletePromises.push(deleteDoc(notificationRef));
          });
          await Promise.all(deletePromises);

          // Refetch to ensure state is synchronized
          await fetchNotifications();

          setIsLoading(false);
          Swal.fire({
            title: "Notifications cleared!",
            text: "All your notifications have been cleared.",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });
        } catch (err) {
          console.error(err);
          alert("An error occured while clearing notifications");
          setIsLoading(false);
        }
      }
    });
  };

  const [totalChampionPoints, setTotalChampionPoints] = useState(0);
  useEffect(() => {
    if (!user?.uid) return;

    let mounted = true;

    (async () => {
      try {
        setIsLoading(true);
        const url = `https://us-central1-sport-league-e35d7.cloudfunctions.net/getChampionPoints?uid=${encodeURIComponent(
          user.uid,
        )}`;

        const r = await fetch(url, { method: "GET" });
        if (!r.ok) throw new Error(`HTTP ${r.status}: ${await r.text()}`);
        const j = await r.json();

        if (mounted) setTotalChampionPoints(j?.total ?? 0);
      } catch (err) {
        if (mounted) {
          console.error(err);
          alert("An error occured while calculating total champion points");
        }
      } finally {
        if (mounted) setIsLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [user?.uid]);

  if (isLoading || loading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div className="App">
      <WelcomeTutorialModal />
      {/* <div id='desktopComingSoonScreen'>
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 300,
          }}
        />
        <p id='desktopComingSoonHeader'>
          COMING SOON
        </p>
        <p id='desktopComingSoonSubheader'>
          on desktop
        </p>
      </div> */}
      {sidebarIsOpen ? (
        <div id="sidebar">
          <div id="sidebarContainer">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "end",
              }}
            >
              <IoClose onClick={toggleSidebar} />
            </div>
            {/* <div className='navLanguageToggle'>
                <p onClick={() => toggleLanguage('en')} style={{paddingRight: '0.5rem', borderRight: '1px solid white'}} className={classnames(
                  {
                    active: activeLanguage === 'en'
                  }
                )}>
                  🇺🇸 EN
                </p>
                <p onClick={() => toggleLanguage('es')} style={{paddingLeft: '0.5rem'}} className={classnames(
                  {
                    active: activeLanguage === 'es'
                  }
                )}>
                  🇪🇸 ES
                </p>
              </div> */}
            {!user ? (
              <a className="navbarBtn" href="/login">
                {`${t("signIn").toUpperCase()} / ${t(
                  "register",
                ).toUpperCase()}`}
              </a>
            ) : null}
            {/* Show Play Now in the mobile sidebar for logged in users */}
            {user ? (
              <a
                className="navbarBtn"
                href="/play"
                onClick={() => toggleSidebar()}
                style={{ marginTop: "0.5rem" }}
              >
                {t("playNow").toUpperCase()}
              </a>
            ) : null}

            {userRole === "admin" ? (
              <a
                href="/admin"
                className={classnames("navbarItem", {
                  active: currentRoute === "admin",
                })}
              >
                ADMIN
              </a>
            ) : null}
            <a
              href="/"
              className={classnames("navbarItem", {
                active: currentRoute === "",
              })}
            >
              {t("homeMenuItem").toUpperCase()}
            </a>
            {SHOP_ENABLED ? (
              <a
                href="/shop"
                className={classnames("navbarItem", {
                  active: currentRoute === "shop",
                })}
              >
                {t("shop").toUpperCase()}
              </a>
            ) : null}
            <a
              href="/about-us"
              className={classnames("navbarItem", {
                active: currentRoute === "about-us",
              })}
            >
              {t("aboutUs").toUpperCase()}
            </a>
            <a
              href="/sports"
              className={classnames("navbarItem", {
                active: currentRoute === "sports",
              })}
            >
              {t("sports").toUpperCase()}
            </a>
            <a
              href="/news"
              className={classnames("navbarItem", {
                active: currentRoute === "news",
              })}
            >
              {t("whatsNew").toUpperCase()}
            </a>
            <a
              href="/contact"
              className={classnames("navbarItem", {
                active: currentRoute === "contact",
              })}
            >
              {t("contact").toUpperCase()}
            </a>
            {/* <div className='navLanguageToggle'> */}
            <Select
              closeMenuOnSelect={false}
              components={animatedComponents}
              isMulti={false}
              options={languageOptions}
              value={language}
              onChange={(e) => setLang(e)}
              className="selectInput"
            />
            {/* <p onClick={() => toggleLanguage('en')} style={{paddingRight: '1rem', borderRight: '2px solid white'}} className={classnames(
                {
                  active: activeLanguage === 'en'
                }
              )}>
                🇺🇸&nbsp;&nbsp;EN
              </p>
              <p onClick={() => toggleLanguage('es')} style={{paddingLeft: '1rem'}} className={classnames(
                {
                  active: activeLanguage === 'es'
                }
              )}>
                🇪🇸&nbsp;&nbsp;ES
              </p> */}
            {/* </div> */}
          </div>
        </div>
      ) : null}
      <section>
        <header>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <a href="/">
              <img
                alt="logo"
                src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01_-_SL_Logo_2_qqmpsb.png?alt=media&token=9cc7396f-1f27-4048-8422-2f94f89a5fd8"
                style={{
                  width: 100,
                }}
                className="hideOnMobile"
              />
              <img
                alt="logo"
                src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
                style={{
                  width: 100,
                }}
                className="hideOnDesktop"
              />
            </a>
          </div>
          <div
            id="desktopNavbarItems"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <a
              href="/"
              className={classnames("navbarItem", {
                active: currentRoute === "",
              })}
            >
              {t("homeMenuItem").toUpperCase()}
            </a>
            <a
              href="/about-us"
              className={classnames("navbarItem", {
                active: currentRoute === "about-us",
              })}
            >
              {t("aboutUs").toUpperCase()}
            </a>
            <a
              href="/sports"
              className={classnames("navbarItem", {
                active: currentRoute === "sports",
              })}
            >
              {t("sports").toUpperCase()}
            </a>
            <a
              href="/news"
              className={classnames("navbarItem", {
                active: currentRoute === "news",
              })}
            >
              {t("news").toUpperCase()}
            </a>
            <a
              href="/contact"
              className={classnames("navbarItem", {
                active: currentRoute === "contact",
              })}
            >
              {t("contact").toUpperCase()}
            </a>
            {SHOP_ENABLED ? (
              <a
                href="/shop"
                className={classnames("navbarItem", {
                  active: currentRoute === "shop",
                })}
              >
                {t("shop").toUpperCase()}
              </a>
            ) : null}
            <p
              onClick={toggleLanguage}
              className="navbarItem hideOnMobile"
              style={{ color: "#FABB00" }}
            >
              {language?.value === "en"
                ? "EN 🇺🇸"
                : language?.value === "es"
                  ? "ES 🇪🇸"
                  : null}
            </p>
            {userRole === "admin" ? (
              <a
                href="/admin"
                className={classnames("navbarItem", {
                  active: currentRoute === "admin",
                })}
              >
                ADMIN
              </a>
            ) : null}
            {user ? (
              <>
                <TbWallet
                  className="hideOnMobile"
                  onClick={toggleWalletModal}
                  style={{
                    width: 30,
                    height: 30,
                    color: "#FABB00",
                    marginRight: "0.75rem",
                    cursor: "pointer",
                  }}
                />
                <div id="notificationBellContainer">
                  <TbBell
                    className="hideOnMobile"
                    onClick={toggleNotificationsModal}
                    style={{
                      width: 30,
                      height: 30,
                      color: "#FABB00",
                      marginRight: "0.75rem",
                      marginBottom: "-0.2rem",
                      cursor: "pointer",
                    }}
                  />
                  {notifications?.find(
                    (notification) => !notification.isRead,
                  ) ? (
                    <div id="notificationBellAlert"></div>
                  ) : null}
                </div>
              </>
            ) : null}
            {!user ? (
              <a className="navbarBtn" href="/login">
                {t("signIn").toUpperCase()} / {t("register").toUpperCase()}
              </a>
            ) : (
              <a
                className="navbarItem"
                href="/account"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginRight: 0,
                }}
              >
                <Avatar
                  src={userAvatar}
                  alt={userData?.displayName || "avatar"}
                  size={35}
                  user={userData}
                />
              </a>
            )}
            {/* <div className='navLanguageToggle'>
              <p onClick={() => toggleLanguage('en')} style={{paddingRight: '0.5rem', borderRight: '1px solid white'}} className={classnames(
                {
                  active: activeLanguage === 'en'
                }
              )}>
                🇺🇸 EN
              </p>
              <p onClick={() => toggleLanguage('es')} style={{paddingLeft: '0.5rem'}} className={classnames(
                {
                  active: activeLanguage === 'es'
                }
              )}>
                🇪🇸 ES
              </p>
            </div> */}
            {user ? (
              <a
                className="navbarBtn"
                href="/play"
                style={{ marginLeft: "1.75rem" }}
              >
                {t("playNow").toUpperCase()}
              </a>
            ) : null}
          </div>
          <div
            className="hideOnDesktop"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {user ? (
              <>
                <TbWallet
                  onClick={toggleWalletModal}
                  style={{
                    width: 30,
                    height: 30,
                    color: "#FABB00",
                    marginRight: "0.75rem",
                  }}
                />
                <div id="notificationBellContainer">
                  <TbBell
                    onClick={toggleNotificationsModal}
                    style={{
                      width: 30,
                      height: 30,
                      color: "#FABB00",
                      marginRight: "0.75rem",
                      marginBottom: "-0.2rem",
                    }}
                  />
                  {notifications?.find(
                    (notification) => !notification.isRead,
                  ) ? (
                    <div id="notificationBellAlert"></div>
                  ) : null}
                </div>
              </>
            ) : null}
            <Modal
              id="walletModal"
              isOpen={walletModalIsOpen}
              toggle={toggleWalletModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader">
                  <div></div>
                  <IoClose onClick={toggleWalletModal} />
                </div>
                <div>
                  <h1>{t("yourWallet").toUpperCase()}</h1>
                  <div style={{ marginTop: "1rem" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          width: "30%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "#111835",
                          padding: "0.5rem",
                          borderRadius: 15,
                        }}
                      >
                        <p style={{ marginBottom: 0, fontSize: 20 }}>⭐</p>
                        <p
                          style={{
                            color: "#FFFFFF",
                            marginBottom: 0,
                            fontSize: 20,
                          }}
                        >
                          {userData?.starCoins ? userData.starCoins : 0}
                        </p>
                        <p
                          style={{
                            color: "#FFFFFF",
                            fontFamily: "Oswald",
                            fontWeight: 500,
                            fontSize: 16,
                            marginBottom: "0.25rem",
                            textAlign: "center",
                          }}
                        >
                          {t("starCoins").toUpperCase()}
                        </p>
                      </div>
                      <div
                        style={{
                          width: "30%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "#111835",
                          padding: "0.5rem",
                          borderRadius: 15,
                        }}
                      >
                        <p style={{ marginBottom: 0, fontSize: 20 }}>🏆</p>
                        <p
                          style={{
                            color: "#FFFFFF",
                            marginBottom: 0,
                            fontSize: 20,
                          }}
                        >
                          {totalChampionPoints ? totalChampionPoints : 0}
                        </p>
                        <p
                          style={{
                            color: "#FFFFFF",
                            fontFamily: "Oswald",
                            fontWeight: 500,
                            fontSize: 16,
                            marginBottom: "0.25rem",
                            textAlign: "center",
                          }}
                        >
                          {t("championPoints").toUpperCase()}
                        </p>
                      </div>
                      <div
                        style={{
                          width: "30%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "#111835",
                          padding: "0.5rem",
                          borderRadius: 15,
                        }}
                      >
                        <p style={{ marginBottom: 0, fontSize: 20 }}>🎟️</p>
                        <p
                          style={{
                            color: "#FFFFFF",
                            marginBottom: 0,
                            fontSize: 20,
                          }}
                        >
                          {userData?.tickets
                            ? userData.tickets.toLocaleString()
                            : 0}
                        </p>
                        <p
                          style={{
                            color: "#FFFFFF",
                            fontFamily: "Oswald",
                            fontWeight: 500,
                            fontSize: 16,
                            marginBottom: "0.25rem",
                            textAlign: "center",
                          }}
                        >
                          {t("tickets").toUpperCase()}
                        </p>
                      </div>
                    </div>
                    <a href="/account">
                      <Button
                        className="primaryBtn"
                        style={{ width: "100%", marginTop: "1rem" }}
                      >
                        {t("viewDetails").toUpperCase()}
                      </Button>
                    </a>
                  </div>
                </div>
              </ModalBody>
            </Modal>
            <Modal
              id="notificationsModal"
              isOpen={notificationsModalIsOpen}
              toggle={toggleNotificationsModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader">
                  <div></div>
                  <IoClose onClick={toggleNotificationsModal} />
                </div>
                <div>
                  <h1 style={{ display: "flex", alignItems: "center" }}>
                    {t("notifications").toUpperCase()}
                    <div
                      id="clearNotificationsIconContainer"
                      onClick={clearNotifications}
                    >
                      <AiOutlineClear />
                    </div>
                  </h1>
                  <div style={{ marginTop: "1rem" }}>
                    {notifications?.length > 0 ? (
                      notifications?.map((notification, index) => {
                        return (
                          <div
                            key={notification.uid || notification.id || index}
                            onClick={() => markNotificationAsRead(notification)}
                            className="notificationsPageNotificationContainer"
                            style={{
                              paddingLeft: "1rem",
                              paddingRight: "1rem",
                              backgroundColor: "#111835",
                              boxShadow: "none",
                              cursor: notification.isRead
                                ? "default"
                                : "pointer",
                            }}
                          >
                            <p className="notificationTitle">
                              {notification.title}
                            </p>
                            <p className="notificationDescription">
                              {notification.description}
                            </p>
                            <p className="notificationDate">
                              {new Date(
                                notification.dateCreated,
                              ).toLocaleDateString("de-DE")}{" "}
                              {new Date(
                                notification.dateCreated,
                              ).toLocaleTimeString("en-US", {
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true,
                              })}
                            </p>
                            {!notification.isRead ? (
                              <MdNewReleases style={{ marginRight: -9 }} />
                            ) : null}
                          </div>
                        );
                      })
                    ) : (
                      <p
                        style={{
                          textAlign: "center",
                          marginTop: "2rem",
                          marginBottom: "1.5rem",
                        }}
                      >
                        {t("youHaveNoNotificationsYet")}
                      </p>
                    )}
                    <a href="/account/notifications">
                      <Button
                        className="primaryBtn"
                        style={{ width: "100%", marginTop: "0.5rem" }}
                      >
                        {t("seeMore").toUpperCase()}
                      </Button>
                    </a>
                  </div>
                </div>
              </ModalBody>
            </Modal>
            {user ? (
              <a
                className="navbarItem"
                href="/account"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginRight: 0,
                }}
              >
                <Avatar
                  src={userAvatar}
                  alt={userData?.displayName || "avatar"}
                  size={40}
                  user={userData}
                  className="hideOnDesktop"
                />
              </a>
            ) : null}
            <FiMenu id="menuToggler" onClick={toggleSidebar} />
          </div>
        </header>
        <Router
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <Routes>
            {!user ? (
              <>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
              </>
            ) : (
              <>
                <Route path="/login" element={<PostAuthRedirect />} />
                <Route path="/register" element={<PostAuthRedirect />} />
                <Route path="/reset-password" element={<Navigate to="/" />} />
              </>
            )}
            <Route path="/" element={<DashboardPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route
              path="/vision-and-mission"
              element={<VisionAndMissionPage />}
            />
            <Route path="/sports" element={<SportsPage />} />
            <Route path="/news" element={<NewsPage />} />
            {/* Public so a shared tournament link is viewable without login.
                Joining still requires auth (handled inside LeaguePage). */}
            <Route
              path="/play/leagues/:leagueUid"
              element={<LeaguePage />}
            />
            <Route
              path="/news/articles/:articleId"
              element={<NewsArticlePage />}
            />
            <Route path="/contact" element={<ContactPage />} />
            {/* Shop routes are kept intact but redirect to /play while the
                shop is disabled (SHOP_ENABLED). Re-enable by flipping the flag. */}
            <Route
              path="/shop"
              element={SHOP_ENABLED ? <ShopPage /> : <Navigate to="/play" replace />}
            />
            <Route
              path="/shop/checkout"
              element={
                SHOP_ENABLED ? <CheckoutPage /> : <Navigate to="/play" replace />
              }
            />
            <Route
              path="/shop/payment-successful/:orderUid"
              element={
                SHOP_ENABLED ? (
                  <PaymentSuccessfulPage />
                ) : (
                  <Navigate to="/play" replace />
                )
              }
            />
            <Route
              path="/shop/payment-unsuccessful/:orderUid"
              element={
                SHOP_ENABLED ? (
                  <PaymentUnsuccessfulPage />
                ) : (
                  <Navigate to="/play" replace />
                )
              }
            />
            {user ? (
              <>
                <Route path="/account" element={<AccountPage />} />
                <Route path="/account/profile" element={<ProfilePage />} />
                <Route
                  path="/account/profile/change-avatar"
                  element={<ChangeAvatarPage />}
                />
                <Route
                  path="/account/profile/change-banner"
                  element={<ChangeBannerPage />}
                />
                <Route
                  path="/account/profile/change-username"
                  element={<ChangeUsernamePage />}
                />
                <Route
                  path="/account/profile/user-info"
                  element={<UserInfoPage />}
                />
                <Route
                  path="/account/notifications"
                  element={<NotificationsPage />}
                />
                <Route
                  path="/account/challenges"
                  element={<ChallengesPage />}
                />
                <Route path="/account/friends" element={<FriendsPage />} />
                <Route
                  path="/account/friends/:friendUsername"
                  element={<SingleUserPage />}
                />
                <Route
                  path="/champions-road/:friendUid"
                  element={<ChampionsRoadPage />}
                />
                <Route
                  path="/achievements/:friendUid"
                  element={<AchievementsPage />}
                />
                <Route
                  path="/account/champions-road"
                  element={<ChampionsRoadPage />}
                />
                <Route
                  path="/account/achievements"
                  element={<AchievementsPage />}
                />
                <Route path="/account/wallet" element={<WalletHistoryPage />} />
                <Route path="/play" element={<PlayPage />} />
                <Route
                  path="/play/join-a-league"
                  element={<JoinALeaguePage />}
                />
                {/* /play/leagues/:leagueUid is registered as a public route
                    above so it works without login. */}
                <Route
                  path="/play/leagues/:leagueUid/rooms/:roomUid"
                  element={<RoomPage />}
                />
                <Route path="/forums/:roomUid" element={<ChatRoomPage />} />
              </>
            ) : (
              <Route path="/account" element={<Navigate to="/" />} />
            )}
            {userRole === "admin" ? (
              <>
                <Route path="/admin" element={<AdminPage />} />
                <Route
                  path="/admin/users/:userUid"
                  element={<AdminUserPage />}
                />
                <Route
                  path="/admin/groups/create"
                  element={<AdminCreateGroupPage />}
                />
                <Route
                  path="/admin/groups/recover-corrupted"
                  element={<RecoverCorruptedGroups />}
                />
                <Route
                  path="/admin/groups/:groupUid"
                  element={<AdminSingleGroupPage />}
                />
                <Route
                  path="/admin/tournaments/:roomUid"
                  element={<AdminSingleRoomPage />}
                />
                <Route
                  path="/admin/tournaments/create"
                  element={<AdminCreateRoomPage />}
                />
                <Route
                  path="/admin/events/create"
                  element={<AdminCreateEventPage />}
                />
                <Route
                  path="/admin/leagues/create"
                  element={<AdminCreateLeaguePage />}
                />
                <Route
                  path="/admin/leagues/:leagueUid"
                  element={<AdminSingleLeaguePage />}
                />
                <Route
                  path="/admin/rewards/create"
                  element={<AdminCreateRewardPage />}
                />
                <Route
                  path="/admin/rewards/:rewardUid"
                  element={<AdminSingleRewardPage />}
                />
                <Route
                  path="/admin/rewards/history"
                  element={<AdminRewardRedemptionHistoryPage />}
                />
                <Route
                  path="/admin/wallet-transactions"
                  element={<AdminWalletTransactionsPage />}
                />
                <Route
                  path="/admin/prize-distributions"
                  element={<AdminPrizeDistributionsPage />}
                />
                <Route
                  path="/admin/coupons/create"
                  element={<AdminCreateCouponPage />}
                />
                <Route
                  path="/admin/coupons/:couponUid"
                  element={<AdminSingleCouponPage />}
                />
                <Route
                  path="/admin/news/articles/:articleId"
                  element={<AdminNewsArticlePage />}
                />
                <Route
                  path="/admin/news/create-article/:articleType"
                  element={<AdminCreateNewsArticlePage />}
                />
                <Route
                  path="/admin/bundles/create"
                  element={<AdminCreateBundlePage />}
                />
                <Route
                  path="/admin/bundles/:bundleUid"
                  element={<AdminSingleBundlePage />}
                />
                <Route
                  path="/admin/products/:productUid"
                  element={<AdminSingleProductPage />}
                />
                <Route
                  path="/admin/products/create"
                  element={<AdminCreateProductPage />}
                />
                {/* BANNERS */}
                <Route
                  path="/admin/banners/:bannerUid"
                  element={<AdminSingleBannerPage />}
                />
                <Route
                  path="/admin/banners/add"
                  element={<AdminAddBannerPage />}
                />
              </>
            ) : null}
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditionsPage />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          </Routes>
        </Router>
      </section>
      {/* DESKTOP FOOTER */}
      <footer id="desktopFooter">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: "2rem",
            borderBottom: "1px solid rgba(255, 255, 255, 0.063)",
          }}
        >
          <div>
            <img
              alt="logo"
              src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
              style={{
                width: 100,
                marginBottom: "2rem",
              }}
            />
            <p style={{ marginBottom: "1rem" }}>{t("keepInTouchWithUs")}</p>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "2rem",
              }}
            >
              <a
                href="https://www.instagram.com/sportleague.sv"
                target="_blank"
                rel="noreferrer"
                className="socialsIconContainer"
                style={{ marginLeft: 0, marginRight: 0 }}
              >
                <BsInstagram />
              </a>
              <a
                href="https://www.facebook.com/people/Sport-League/100086265026537"
                target="_blank"
                rel="noreferrer"
                className="socialsIconContainer"
                style={{ marginRight: 0 }}
              >
                <FaFacebookF />
              </a>
              <a
                href="https://twitter.com/sportleaguesv?t=GCJQbcarcRruthH2qq2WRA"
                target="_blank"
                rel="noreferrer"
                className="socialsIconContainer"
                style={{ marginRight: 0 }}
              >
                <BsTwitterX />
              </a>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p style={{ marginBottom: "1rem", fontWeight: 700 }}>
                {t("company")}
              </p>
              <a
                href="/about-us"
                style={{ fontWeight: 500, marginBottom: "0.5rem" }}
              >
                {t("aboutUs")}
              </a>
              <a href="/vision-and-mission" style={{ fontWeight: 500 }}>
                {t("visionAndMission")}
              </a>
            </div>
            <div
              style={{
                marginLeft: "3rem",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p style={{ marginBottom: "1rem", fontWeight: 700 }}>
                {t("customerService")}
              </p>
              <a
                href="/play"
                style={{ fontWeight: 500, marginBottom: "0.5rem" }}
              >
                {t("rules")}
              </a>
              <a
                href="/contact"
                style={{ fontWeight: 500, marginBottom: "0.5rem" }}
              >
                {t("contact")}
              </a>
              {/* <a href='/' style={{fontWeight: 500,  marginBottom: '0.5rem'}}>
                  Website security
                </a> */}
              <a
                href="/privacy-policy"
                style={{ fontWeight: 500, marginBottom: "0.5rem" }}
              >
                {t("privacyPolicy")}
              </a>
              {/* <a href='/' style={{fontWeight: 500,  marginBottom: '0.5rem'}}>
                  Terms of Use
                </a> */}
              <a href="/terms-and-conditions" style={{ fontWeight: 500 }}>
                {t("terms&Conditions")}
              </a>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            fontSize: 12,
          }}
        >
          <p style={{ width: "65%" }}>
            Resultados Deportivos Varios S.A. de C.V. //
            <br />
            NIT: 0614-250823-107-6 // Consultorias y gestiones de servicios
            informaticos // Prolongación Avenida Masferrer Norte, Calle Antigua
            Cantón El Carmen, entre Pasaje 9, Urbanización Monte Alto, Colonia
            Escalón. //
            <br />
            info@sportleague.net
          </p>
          <p style={{ width: "30%", textAlign: "right" }}>
            Copyright © 2024 Sport League. {t("allRightsReserved")}.
          </p>
        </div>
      </footer>
      {/*  */}
      {/* MOBILE FOOTER */}
      <footer id="mobileFooter">
        <div>
          <img
            alt="logo"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
            style={{
              width: 100,
              marginBottom: "2rem",
            }}
          />
          <p style={{ marginBottom: "1rem" }}>{t("keepInTouchWithUs")}</p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginBottom: "2rem",
          }}
        >
          <a
            href="https://www.instagram.com/sportleague.sv"
            target="_blank"
            rel="noreferrer"
            className="socialsIconContainer"
          >
            <BsInstagram />
          </a>
          <a
            href="https://www.facebook.com/people/Sport-League/100086265026537"
            target="_blank"
            rel="noreferrer"
            className="socialsIconContainer"
            style={{ marginLeft: "1rem", marginRight: "1rem" }}
          >
            <FaFacebookF />
          </a>
          <a
            href="https://twitter.com/sportleaguesv?t=GCJQbcarcRruthH2qq2WRA"
            target="_blank"
            rel="noreferrer"
            className="socialsIconContainer"
          >
            <BsTwitterX />
          </a>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            borderTop: "1px solid #ffffff10",
            borderBottom: "1px solid #ffffff10",
            marginBottom: "2rem",
          }}
        >
          <p
            onClick={toggleFooterCompanyAccordion}
            style={{ marginTop: "1rem", marginBottom: "1rem" }}
          >
            {t("company")}
            {footerCompanyAccordionIsOpen ? (
              <IoChevronUp style={{ marginLeft: "0.5rem" }} />
            ) : (
              <IoChevronDown style={{ marginLeft: "0.5rem" }} />
            )}
          </p>
          {footerCompanyAccordionIsOpen && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <a
                href="/about-us"
                style={{ fontWeight: 500, marginBottom: "1rem" }}
              >
                {t("aboutUs")}
              </a>
              <a
                href="/vision-and-mission"
                style={{ fontWeight: 500, marginBottom: "1rem" }}
              >
                {t("visionAndMission")}
              </a>
            </div>
          )}
          <p
            onClick={toggleFooterCustomerServiceAccordion}
            style={{ marginBottom: "1rem" }}
          >
            {t("customerService")}
            {footerCustomerServiceAccordionIsOpen ? (
              <IoChevronUp style={{ marginLeft: "0.5rem" }} />
            ) : (
              <IoChevronDown style={{ marginLeft: "0.5rem" }} />
            )}
          </p>
          {footerCustomerServiceAccordionIsOpen && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <a
                href="/play"
                style={{ fontWeight: 500, marginBottom: "0.5rem" }}
              >
                {t("rules")}
              </a>
              <a
                href="/contact"
                style={{ fontWeight: 500, marginBottom: "0.5rem" }}
              >
                {t("contact")}
              </a>
              {/* <a href='/' style={{fontWeight: 500,  marginBottom: '0.5rem'}}>
                  Website security
                </a> */}
              <a
                href="/privacy-policy"
                style={{ fontWeight: 500, marginBottom: "0.5rem" }}
              >
                {t("privacyPolicy")}
              </a>
              {/* <a href='/' style={{fontWeight: 500,  marginBottom: '0.5rem'}}>
                  Terms of Use
                </a> */}
              <a
                href="/terms-and-conditions"
                style={{ fontWeight: 500, marginBottom: "1rem" }}
              >
                {t("terms&Conditions")}
              </a>
            </div>
          )}
        </div>
        <p style={{ marginBottom: "2rem" }}>
          Resultados Deportivos Varios S.A. de C.V. //
          <br />
          NIT: 0614-250823-107-6 // Consultorias y gestiones de servicios
          informaticos // Prolongación Avenida Masferrer Norte, Calle Antigua
          Cantón El Carmen, entre Pasaje 9, Urbanización Monte Alto, Colonia
          Escalón. //
          <br />
          info@sportleague.net
        </p>
        <p>Copyright © 2024 Sport League. {t("allRightsReserved")}.</p>
      </footer>
      {/*  */}
    </div>
  );
}

export default App;
